import { render } from "./RelationLink.vue?vue&type=template&id=cf18d344"
import script from "./RelationLink.vue?vue&type=script&lang=js"
export * from "./RelationLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__